<template>
  <div>
      <div class="container-fluid">
          <div class="row">
            <div class="col-sm-12 text-center mb-4">
              <h4 class="mb-0">
                Por favor captura tus datos personales.
              </h4>
              <small>Los campos marcados con * son obligatorios. Y debes contar con al menos 18 años cumplidos</small>
            </div>
          </div>
          <div class="row">
              <div class="col-md-6">
                  <div :class="{'form-group': true}">
                      <label for="birthstate-input">{{$t('form.first_name')}} *</label>
                      <input type="text"
                      :class="{'is-invalid': $v.personal.first_name.$invalid, 'form-control': true}"
                      v-model="personal.first_name"
                      @input="$v.personal.first_name.$touch()"
                      placeholder="">
                      <div class="form-control-feedback" v-if="!$v.personal.first_name.required">
                      {{ $t('form.required') }}
                      </div>
                  </div>
              </div>
              <div class="col-md-6">
                <div :class="{'form-group': true}">
                    <label for="birthstate-input">{{$t('form.last_name')}} *</label>
                    <input type="text"
                    :class="{'is-invalid': $v.personal.last_name.$invalid, 'form-control': true}"
                    v-model="personal.last_name"
                    @input="$v.personal.last_name.$touch()"
                    placeholder="">
                    <div class="form-control-feedback" v-if="!$v.personal.last_name.required">
                    {{ $t('form.required') }}
                    </div>
                </div>
              </div>
          </div>
          <div class="row">
              <div class="col-md-12">
                <div :class="{'form-group': true}">
                    <label for="birthstate-input">{{$t('form.email')}} *</label>
                    <input type="text"
                    :class="{'is-invalid': $v.personal.email.$invalid, 'form-control': true}"
                    v-model="personal.email"
                    @input="$v.personal.email.$touch()"
                    placeholder="">
                    <div class="form-control-feedback" v-if="!$v.personal.email.required">
                    {{ $t('form.required') }}
                    </div>
                </div>
              </div>
          </div>
          <div class="row">
              <div class="col-md-6">
                <div :class="{'is-invalid': $v.personal.mobile_phone.$invalid, 'form-group': true}">
                    <label for="birthstate-input">{{$t('form.mobile_phone')}} *</label>
                    <input type="number"
                    :class="{'is-invalid': $v.personal.mobile_phone.$invalid, 'form-control': true}"
                    v-model="personal.mobile_phone"
                    @input="$v.personal.mobile_phone.$touch()"
                    maxlength="10"
                    placeholder="">
                    <div class="form-control-feedback" >
                      <span v-if="!$v.personal.mobile_phone.required">
                        {{ $t('form.required') }}
                      </span>
                      <span v-if="!$v.personal.mobile_phone.minLength||!$v.personal.mobile_phone.maxLength">
                        {{ $t('form.phone_length') }}
                      </span>
                    </div>
                </div>
              </div>
              <div class="col-md-6">
                <div :class="{'is-invalid': $v.personal.birthdate.$invalid, 'form-group': true}" >
                  <label>{{$t('form.birthday')}} * </label>
                  <div class="input-group">
                    <span class="input-group-btn">
                      <button class="btn btn-secondary" type="button" data-toggle>
                        <i class="fa fa-calendar">
                          <span aria-hidden="true" class="sr-only">Toggle</span>
                        </i>
                      </button>
                    </span>
                    <flat-pickr
                      v-model="personal.birthdate"
                      :config="ageConfig"
                      class="form-control "
                      placeholder="Select date"
                      name="ageSelector"
                      ref="ageSelector"
                    >
                    </flat-pickr>
                  </div>
                  <div class="form-control-feedback" v-if="!$v.personal.birthdate.required">
                    {{ $t('form.required') }}
                  </div>
                </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>

// eslint-disable-next-line
import { validationMixin } from 'vuelidate'
// eslint-disable-next-line
import { required, minLength, maxLength, email} from 'vuelidate/lib/validators'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
var moment = require('moment')
const today = moment().subtract('years', 18).format('YYYY-MM-DD')
export default {
  name: 'FormStepOne',
  props: [
    'data'
  ],
  data () {
    return {
      step: 1,
      test: 'lorem',
      personal: {
        first_name: '',
        last_name: '',
        email: '',
        mobile_phone: '',
        birthdate: ''
      },
      ageConfig: {
        wrap: true,
        minDate: null,
        maxDate: today,
        altFormat: 'Y-m-d',
        altInput: true,
        dateFormat: 'Y-m-d'
      }
    }
  },
  components: {
    flatPickr
  },
  validations: {
    personal: {
      first_name: {
        required
      },
      last_name: {
        required
      },
      email: {
        required,
        email
      },
      mobile_phone: {
        required,
        minLength: minLength(10),
        maxLength: maxLength(10)
      },
      birthdate: {
        required
      }
      // form: ['first_name', 'last_name', 'email', 'mobile_phone', 'birthdate']
    }
  },
  computed: {
    isSelling () {
      return this.$store.state.isSelling.process
    },
    isSellingIndex () {
      return this.$store.state.isSelling.index
    },
    statusForm () {
      return this.$v.personal.$invalid
    }
  },
  watch: {
    statusForm (value) {
      if (value === false) {
        this.personal.sku = this.data.sku
        this.personal.payment_period = this.data.payment_period
      }
    }
    // statusForm (value) {
    //   if (value === false) {
    //     this.$emit('valid-data', [this.personal, this.isValid, this.step])
    //   } else {
    //     this.$emit('valid-data', [this.personal, this.isValid, this.step])
    //   }
    //   // this.$emit('valid-form', this.isValid)
    // }
  },
  mounted () {
  },
  methods: {
    validate () {
      console.log('validando')
      this.$v.personal.$touch()
      var isValid = !this.$v.personal.$invalid
      console.log('es valido', isValid)
      this.$emit('on-validate', this.personal, isValid)
      return isValid
    }
  }
}
/* {
  payment_token: 'tok_1Cm8XFG9eOPeXBTVIxjYNHIF',
  user: {
    username: 'test56ApiRest',
    password: 'Qwerty123'
  },
  data: {
    product_id: 406,
    payment_period: 'Mensual',
    first_name: 'Test56',
    last_name: 'ApiRest',
    email: 'test56apirest@yopmail.com',
    mobile_phone: '1234567890',
    address_1: 'Test Avenue',
    address_2: '1200',
    city: 'Houston',
    state: 'TX',
    postcode: '77001',
    birthdate: '1981-10-07',
    seller_id: 'socio-211',
    SSN: '234234234234',
    ITIN: '234234324234324'
  },
  add_kit: true
} */
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.flatpickr-months .flatpickr-month {
  height: 48px;
}
.flatpickr-current-month input.cur-year {
  border: 1px solid silver;
  margin-bottom: 10px;
  margin-left: 10px;
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/FormStepOne.vue